import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';

import Galleries from 'api/resources/galleries';
import { processErrorByAlert } from 'utils/getErrors';

import GalleryForm from 'admin-editor/containers/GalleryForm';

import Main from 'styled/Page/Main';

export class GalleryCreatePage extends React.PureComponent {
  state = {
    loading: false,
  }

  createGallery = async ({ data, isExit } = {}) => {
     try {
      const response = await Galleries.create({
        body: { data },
      });

      Alert.success('Галерея успешно создана');
      this.setState({ loading: false });

      const redirectRoute = isExit ? '/galleries' : `/galleries/${response.data.id}`;
      this.props.history.push(redirectRoute);
    } catch (err) {
      this.setState({ loading: false });
      processErrorByAlert(err);
    }
  }

  render() {
    return (
      <Main>
        <Helmet>
          <title>Создать галерею</title>
        </Helmet>

        <GalleryForm
          saveLoading={this.state.loading}
          onSubmit={this.createGallery}
        />
      </Main>
    );
  }
}

GalleryCreatePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

GalleryCreatePage.defaultProps = {
  history: { push: () => {} },
};

export default withRouter(GalleryCreatePage);
